import type { AnyDocument, PartialDocument } from '../types';

export default function getDocumentReadingProgress(
  currentDoc: AnyDocument | PartialDocument<AnyDocument, 'readingPosition'>,
): number {
  const scrollDepth = currentDoc.readingPosition?.scrollDepth ?? 0;
  return Math.floor(scrollDepth * 100);
}
